import { IApplicationEvent } from '../../../../../apps/idl/src/model/application/IApplicationEvent';
import { EConfigEventType } from './EConfigEventType';

export interface IConfigEvent extends IApplicationEvent {
  data: { configEventType: EConfigEventType };
}